import React from 'react';
import RestInputItem from 'components/RestInput/RestInputItem';

const CommentsForm = props => (
  <div {...props}>
    <RestInputItem source="content" header="comments.content" />
    <RestInputItem source="createdAt" header="comments.createdAt" />
  </div>
);

CommentsForm.propTypes = {};

export default CommentsForm;
